/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { Hint } from '../models/hint.entity';

@Injectable()
export class HintsService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public list(): Observable<Hint[]> {
		return this.http.get<Hint[]>(
			`${this.config.apiUrl}/api/v2/public/hints`,
		);
	}
}
